(function () {
  'use strict';

  var WATCHDOG_MS = 4500;
  var SLOW_LOAD_MS = 7000;

  function connectionLooksSlow() {
    try {
      var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!c) return false;
      if (c.saveData) return true;
      var et = c.effectiveType;
      // Only truly bad links — "3g" is too common and was killing lava.
      if (et === 'slow-2g' || et === '2g') return true;
      if (typeof c.downlink === 'number' && c.downlink > 0 && c.downlink < 0.7) return true;
      if (typeof c.rtt === 'number' && c.rtt > 800) return true;
    } catch (e) {}
    return false;
  }

  function navigationLooksSlow() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav) {
        if (nav.domContentLoadedEventEnd - nav.startTime > 5000) return true;
        if (nav.loadEventEnd > 0 && nav.loadEventEnd - nav.startTime > SLOW_LOAD_MS) return true;
      }
      var timing = performance.timing;
      if (timing && timing.navigationStart) {
        if (timing.domContentLoadedEventEnd - timing.navigationStart > 5000) return true;
        if (timing.loadEventEnd && timing.loadEventEnd - timing.navigationStart > SLOW_LOAD_MS) return true;
      }
    } catch (e) {}
    return false;
  }

  function resourcesLookSlow() {
    try {
      var slow = 0;
      performance.getEntriesByType('resource').forEach(function (entry) {
        if (entry.duration > 2500) slow += 1;
      });
      return slow >= 4;
    } catch (e) {}
    return false;
  }

  function enableLiteMode(reason) {
    var root = document.documentElement;
    if (root.classList.contains('fraire-slow-network')) return;
    root.classList.add('fraire-slow-network');
    root.dataset.fraireLiteReason = reason || 'slow';

    if (document.body) {
      document.body.classList.remove('fraire-hero-pinned');
    } else {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          document.body.classList.remove('fraire-hero-pinned');
        },
        { once: true }
      );
    }

    deferHeroVideos();
    pauseLava();
    window.dispatchEvent(new CustomEvent('fraire:slow-network', { detail: { on: true, reason: reason } }));
  }

  function pauseLava() {
    // Never hide lava from lite-mode — the heat toggle owns on/off.
    // (Previously this broke activation after slow-network heuristics.)
  }

  function deferHeroVideos() {
    document.querySelectorAll('[class*="ai-video-hero-video-background"]').forEach(function (video) {
      if (video.dataset.fraireLiteDone === '1') return;
      video.dataset.fraireLiteDone = '1';
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.preload = 'none';
      try {
        video.pause();
      } catch (e) {}
    });
  }

  function loadHeroVideosIfFast() {
    if (document.documentElement.classList.contains('fraire-slow-network')) return;

    window.requestAnimationFrame(function () {
      document.querySelectorAll('[class*="ai-video-hero-video-background"]').forEach(function (video) {
        if (video.dataset.fraireLoaded === '1') return;
        video.dataset.fraireLoaded = '1';
        video.preload = 'auto';
        video.load();
        if (video.muted) {
          var playAttempt = video.play();
          if (playAttempt && playAttempt.catch) {
            playAttempt.catch(function () {});
          }
        }
      });
    });
  }

  function runWatchdog() {
    if (document.documentElement.classList.contains('fraire-slow-network')) return;
    // Only enter lite mode on real slow-network signals — never just because
    // Shopify third-party scripts keep document.readyState !== 'complete'.
    if (navigationLooksSlow() || resourcesLookSlow() || connectionLooksSlow()) {
      enableLiteMode('watchdog');
    }
  }

  function boot() {
    if (connectionLooksSlow()) {
      enableLiteMode('connection');
    }

    window.addEventListener(
      'load',
      function () {
        if (!document.documentElement.classList.contains('fraire-slow-network') && navigationLooksSlow()) {
          enableLiteMode('load-slow');
        } else {
          loadHeroVideosIfFast();
        }
      },
      { once: true }
    );

    window.setTimeout(runWatchdog, WATCHDOG_MS);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', deferHeroVideos);
    } else {
      deferHeroVideos();
    }

    try {
      var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (conn && conn.addEventListener) {
        conn.addEventListener('change', function () {
          if (connectionLooksSlow()) enableLiteMode('connection-change');
        });
      }
    } catch (e) {}
  }

  window.fraireEnableLiteMode = enableLiteMode;
  boot();
})();
